import React from 'react';
import { Link } from 'react-router-dom';
export function Careers() {
  return <div className="max-w-4xl mx-auto px-6 pt-32 pb-24" data-id="element-3440">
      <div className="mb-16" data-id="element-3441">
        <h1 className="text-4xl font-bold text-white mb-4 font-title" data-id="element-3442">
          Join Giga
        </h1>
        <p className="text-neutral-400 font-body text-lg max-w-2xl" data-id="element-3443">
          We're building an AI assistant platform that connects to every tool
          your team uses. Help us build the future of work.
        </p>
      </div>

      <div className="space-y-12" data-id="element-3444">
        {/* Principal Engineer */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-3445">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-3446">
            <div data-id="element-3447">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-3448">
                Principal Engineer
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-3449">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-3450">
                  Engineering
                </span>
                <span data-id="element-3451">•</span>
                <span data-id="element-3452">Remote</span>
                <span data-id="element-3453">•</span>
                <span data-id="element-3454">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-3455">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-3456">
            <p data-id="element-3457">
              We're looking for a hands-on, senior IC to lead backend
              architecture and systems engineering at Giga. Our product is built
              on Linux VMs (not containers), and uses a custom coding harness
              that interacts directly with operating system primitives.
            </p>

            <div data-id="element-3458">
              <h3 className="text-white font-semibold mb-3" data-id="element-3459">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-3460">
                <li data-id="element-3461">
                  Architect and maintain our core backend infrastructure built
                  primarily in Ruby.
                </li>
                <li data-id="element-3462">
                  Manage and optimize our Linux VM fleet and sysadmin
                  operations.
                </li>
                <li data-id="element-3463">
                  Build and secure the coding harness that allows our AI agents
                  to execute code safely.
                </li>
                <li data-id="element-3464">
                  Navigate and simplify non-straightforward architectural
                  challenges.
                </li>
              </ul>
            </div>

            <div data-id="element-3465">
              <h3 className="text-white font-semibold mb-3" data-id="element-3466">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-3467">
                <li data-id="element-3468">
                  Deep expertise in Ruby and backend systems architecture.
                </li>
                <li data-id="element-3469">
                  Strong Linux sysadmin skills and experience managing VM-based
                  infrastructure.
                </li>
                <li data-id="element-3470">
                  Experience with systems programming and OS-level primitives.
                </li>
                <li data-id="element-3471">
                  Comfortable working in complex, non-standard architectures.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Head of Product */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-3472">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-3473">
            <div data-id="element-3474">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-3475">
                Head of Product
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-3476">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-3477">
                  Product
                </span>
                <span data-id="element-3478">•</span>
                <span data-id="element-3479">Remote</span>
                <span data-id="element-3480">•</span>
                <span data-id="element-3481">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-3482">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-3483">
            <p data-id="element-3484">
              We're looking for a product leader to help us build and maintain a
              software factory where we go from idea to production in less than
              24 hours. You'll shape the direction of our AI assistant platform
              for teams.
            </p>

            <div data-id="element-3485">
              <h3 className="text-white font-semibold mb-3" data-id="element-3486">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-3487">
                <li data-id="element-3488">
                  Lead product strategy and execution for the Giga platform.
                </li>
                <li data-id="element-3489">
                  Drive our rapid iteration cycle (idea to production in
                  &lt;24h).
                </li>
                <li data-id="element-3490">
                  Work closely with engineering to define and prioritize
                  features.
                </li>
                <li data-id="element-3491">
                  Get your hands dirty — this is a builder role, not just
                  high-level strategy.
                </li>
              </ul>
            </div>

            <div data-id="element-3492">
              <h3 className="text-white font-semibold mb-3" data-id="element-3493">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-3494">
                <li data-id="element-3495">
                  You are already AI-native / AI-pilled and deeply understand
                  the current LLM landscape.
                </li>
                <li data-id="element-3496">
                  Proven experience shipping complex B2B SaaS products rapidly.
                </li>
                <li data-id="element-3497">
                  Willingness to be hands-on in a fast-paced startup
                  environment.
                </li>
                <li data-id="element-3498">Strong product intuition and user empathy.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}